import type {
  PlanLimitation,
  PlanServiceDraft,
} from "./CustomSubscriptionServicesEditor";

export type PlanValidationError =
  | "invalidLimitAmount"
  | "repeatedTimeframe"
  | "missingService"
  | "duplicateService";

function hasRepeatedTimeframe(limitations: PlanLimitation[]): boolean {
  const timeframes = limitations.map((limitation) => limitation.timeframe);
  return new Set(timeframes).size !== timeframes.length;
}

function hasInvalidLimitAmount(limitations: PlanLimitation[]): boolean {
  return limitations.some(
    ({ limitAmount }) => !Number.isInteger(limitAmount) || limitAmount <= 0,
  );
}

export function validatePlanLimitations(
  limitations: PlanLimitation[],
): PlanValidationError | null {
  if (hasInvalidLimitAmount(limitations)) return "invalidLimitAmount";
  if (hasRepeatedTimeframe(limitations)) return "repeatedTimeframe";
  return null;
}

export function validatePlanServices(
  services: PlanServiceDraft[],
): PlanValidationError | null {
  if (services.some((service) => service.serviceId <= 0)) {
    return "missingService";
  }
  const serviceIds = services.map((service) => service.serviceId);
  if (new Set(serviceIds).size !== serviceIds.length) {
    return "duplicateService";
  }
  return (
    services
      .map((service) => validatePlanLimitations(service.limitations))
      .find((error) => error !== null) ?? null
  );
}
